import {userUserStore} from "@/store/user";
import pinia from "@/store";
import axios, {AxiosResponse} from "axios";
import {BaseResponse} from "@/types";
import {dayjs, ElNotification} from "element-plus";
import router from "@/router";

export interface HttpOptions {
    url: string;
    method: "POST" | "post" | "GET" | "get";
    data?: any;
    headers?: any;
    name?: string;
}

const instance = axios.create({
    baseURL: import.meta.env.VITE_API_HOST,
});

instance.interceptors.request.use(
    config => {
        const userStore = userUserStore(pinia);
        config.headers["token"] = userStore.token;
        console.log(`携带TOKEN：%c${config.headers["token"]}`, 'color: red');
        console.groupEnd()
        return config;
    },
    error => {
        console.error(error);
    }
);

instance.interceptors.response.use(
    response => {
        const {status, data} = response;
        if (status >= 500) {
            ElNotification.error({
                title: "请求失败",
                message: "服务器出错了，请联系管理员~"
            })
            return Promise.reject(response);
        } else {
            console.groupCollapsed("====== 打印本次响应 =====", "当前时间: " + dayjs().format("YYYY-MM-DD HH:mm:ss.SSS"))
            console.log(`请求URL: %c${response.config.url}`, 'color: green')
            console.log("HTTP状态码：" + status, status === 200 ? "请求成功" : "请求失败");
            console.log("响应数据：", data)
            console.groupEnd()
            if ([400, 404].includes(response.data.code)) {
                const userStore = userUserStore()
                userStore.reset()
                router.push({path: "/index",}).then(() => {});
                return Promise.reject(response);
            }
        }
        return response;
    },
    error => {
        console.groupCollapsed("====== 打印本次响应 =====", "当前时间: " + dayjs().format("YYYY-MM-DD HH:mm:ss.SSS"))
        console.log("本次请求失败")
        console.error(error);
        ElNotification.error({
            title: "请求失败",
            message: error.message
        })
        console.log("====== 打印本次响应 =====", "当前时间: " + dayjs().format("YYYY-MM-DD HH:mm:ss.SSS"))
        console.groupEnd()
        return Promise.reject(error);
    }
);

export const http = <T = any>(options: HttpOptions):
    Promise<AxiosResponse<BaseResponse<T>>> => {
    return new Promise((resolve, reject) => {
        let promise;
        promise = instance({
            method: options.method,
            url: options.url,
            [options.method.toLowerCase() === "get" ? "params" : "data"]: options.data,
            headers: options.headers,
        });
        console.groupCollapsed("====== 打印本次请求 =====", "当前时间: " + dayjs().format("YYYY-MM-DD HH:mm:ss.SSS"))
        console.log(`请求名称: %c${options.name}`, 'color: blue')
        console.log(`请求URL: %c${options.url}`, 'color: green')
        console.log("请求方式: ", options.method)
        console.log("请求参数: ", options.data);
        promise
            ?.then(res => {
                resolve(res);
            })
            .catch(err => {
                reject(err);
            });
    });
};
